@if (labelText) {
  <fieldset>
    <legend class="for">{{ labelText }}</legend>
    <ng-container *ngTemplateOutlet="radioButtonListTemplate"></ng-container>
  </fieldset>
}

@if (!labelText) {
  <ng-container *ngTemplateOutlet="radioButtonListTemplate"></ng-container>
}

<ng-template #radioButtonListTemplate>
  @for (item of items; track item) {
    <div class="form-check form-check-inline">
      <input
        class="form-check-inline"
        [disabled]="isDisabled"
        (touch)="(onTouch)"
        (change)="(onChange)"
        [value]="item.value"
        [(ngModel)]="value"
        [id]="labelForId + item.value"
        [name]="labelForId"
        [attr.name]="uniqueName"
        type="radio"
        />
        <label class="form-check-label" [for]="labelForId + item.value">{{ item.text }}</label>
      </div>
    }
  </ng-template>
